// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from "@sentry/nextjs";
import { Integrations } from "@sentry/tracing";
import { ReportingObserver as ReportingObserverIntegration } from "@sentry/integrations";

const online = ENV_ISONLINE;
const isProd = ENV_ISPROD;
const dsn = "https://4934395531f14046b19f35dc412f8e45@sentry.ezbuy.com/44";

console.log("sentry client online =====> ", online);

const integrations = [
	new ReportingObserverIntegration(),
	new Integrations.BrowserTracing({
		beforeNavigate: (context) => {
			return {
				...context,
				name: replacePathname(location.pathname),
			};
		},
	}),
];

Sentry.init({
	serverName: "OPTIMUS_V2_LITB",
	integrations,
	dsn,
	// Note: if you want to override the automatic release value, do not set a
	// `release` value here - use the environment variable `SENTRY_RELEASE`, so
	// that it will also get attached to your source maps
	// release: SENTRY_RELEASE ? SENTRY_RELEASE.id : NEXT_PUBLIC_COMMIT_SHA,
	tracesSampler: () => {
		return 1;
	},
	environment: online ? "online" : isProd ? "dev" : "test",
	ignoreErrors: [
		"getAttribute",
		// Heavy Ad Intervention
		"Ad was removed",
		"Non-Error promise rejection captured",
	],
	denyUrls: [
		"https://ctrlitb.rightinthebox.com/ctr_tracking.php",
		"https://bat.bing.com/bat.js",
		"https://c.go-mpulse.net",
		"https://s.go-mpulse.net/boomerang/D8XY7-ZTTUT-KNRUR-CTM7D-KLYLX",
	],
});

function replacePathname(pathname = "") {
	if (pathname.match(/\/active\//)) {
		return "/active";
	}
	return pathname;
}
